import { GET_BASE64_FROM_PICTURE_URL } from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { GetPictureBase64Request } from '@1po/1po-bff-fe-spec/generated/picture/GetPictureBase64Request';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

export function sendFetchBase64FromUrlRequestSaga(request: GetPictureBase64Request): WebSocketAction {
  return wsSendAction(GET_BASE64_FROM_PICTURE_URL, request);
}
